import fetch from 'node-fetch';
import {UserLogoutApi, ServicesErrors} from '../../constants';
import {handleResponse, determineErrorLevelForSentry, handleCommonErrorResponse} from '../../utils';
import * as Sentry from '@sentry/browser';
import {History} from 'history';

export function logout(history: History) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
  };
  return fetch(UserLogoutApi, requestOptions)
    .then(handleResponse)
    .catch(error => {
      const errorLevel = determineErrorLevelForSentry(error);

      Sentry.configureScope((scope) => {
        scope.setLevel(errorLevel);
      });

      Sentry.addBreadcrumb({
        category: 'user',
        message: 'Endpoint ' + UserLogoutApi,
        data: {
          error: error,
        },
        level: errorLevel
      });
      Sentry.captureMessage(ServicesErrors.user.logoutUserFailed, errorLevel);
      return handleCommonErrorResponse(error, history)
    });
}
